import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "filter-newsroom-event__filterbuttonarea" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'DateFilterButton',
    props: {
        item: {}
    },
    emits: ['update:period'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("button", {
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('update:period', _ctx.item?.period))),
                    type: "button",
                    class: "filter-newsroom-event__filterbutton"
                }, _toDisplayString(_ctx.item?.title ?? "Select"), 1 /* TEXT */)
            ]));
        };
    }
});
